import * as constants from "../constants/systemsConstants";

const defaultState = {
  all_systems: [],
  loading: false,
};

const systemsReducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.SYSTEM_GET_ALL_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.SYSTEM_GET_ALL_SUCCEEDED:
      return {
        ...state,
        all_systems: data,
        loading: false,
      };
    case constants.SYSTEM_GET_ALL_FAILED:
      return defaultState;
    default:
      return state;
  }
};

export default systemsReducer;